import { useGetDateOfBirthRule, useGetPhoneRule } from '@/hooks';
import { UserDataFormFields } from '../helpers';

export const useGetFormValidations = () => {
  const phoneRule = useGetPhoneRule();
  const dateOfBirthRule = useGetDateOfBirthRule();

  return {
    [UserDataFormFields.PHONE]: [phoneRule],
    [UserDataFormFields.BIRTHDATE]: [dateOfBirthRule],
  }
}
